/*
 * Angular 2 decorators and services
 */
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThemeService } from '@app/shared/services/theme/theme.service';

/**
 *
 * Spinner component.
 * @class SpinnerComponent
 *
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spinner',
  styleUrls: ['./spinner.component.scss'],
  templateUrl: './spinner.component.html',
  standalone: false,
})
export class SpinnerComponent {
  @Input() public message = '';

  public constructor(private themeService: ThemeService) {}

  public get themeType(): string {
    return this.themeService.getThemeType();
  }
}
